// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ZBrKZ","label":"CategoryService_label__34Xu4","location":"CategoryService_location__3_7d3"};